import styled, { css } from 'styled-components';
import { colors } from '../../assets/variables';

const Wrap = styled.div`
  display: flex;
  font-family: 'DM Sans', sans-serif;
  flex-direction: column;
  color: ${colors.primary};
  background-color: #d7f1ff;
  margin-bottom: 16px;
  border-radius: 10px;
  overflow: hidden;
  min-height: 187px;
  width: 100%;
  ${(props) => {
    if (props.isDesktop) {
      return deskTopStyles;
    }
  }}
`;
const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 2em;
  flex-basis: 50%;
  font-family: 'DM Sans', sans-serif;
`;

const Title = styled.h4`
  font-size: 26px;
  font-weight: 600;
  margin: 0 0 10px;
  padding: 5px 0;
  font-family: 'DM Sans', sans-serif;
`;

const Description = styled.p`
  font-size: 18px;
  margin: 0 0 10px;
  min-height: 108px;
  line-height: 1.5;
  color: ${colors.primary};
  font-family: 'DM Sans', sans-serif;
`;
const Disclaimer = styled.p`
  font-size: 15px;
  line-height: 1.5;
  margin-top: 16px;
  margin-bottom: 0px;
  font-family: 'DM Sans', sans-serif;
`;

const Button = styled.button`
  text-decoration: underline;
  text-underline-offset: 8px;
  text-decoration-color: ${colors.action};
  text-decoration-thickness: 2px;
  border: 0;
  background: transparent;
  min-height: 35px;
  cursor: pointer;
  font-weight: 600;
  font-size: 16px;
  text-align: left;
  margin-top: 10px;
  text-transform: none;
  ${(props) => {
    if (props.disabled) {
      return css`
        text-decoration-color: ${colors.darkGray};
      `;
    }
  }}
`;

const deskTopStyles = css`
  flex-direction: row;
  ${Title} {
    font-size: 26px;
    min-height: 62px;
    margin: 0 0 10px;
  }

  ${Content} {
    flex-basis: 60%;
    padding: 4em 2em;
  }
  ${Description} {
    font-size: 18px;
    min-height: 108px;
  }
`;
const Container = styled.div`
  border-radius: 8px;
  padding: 28px;
  background: #d7f1fe;
  margin-bottom: 16px;
  .icon-box {
    background: #abe4fe;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 75px;
    height: 75px;
    margin-bottom: 24px;
    padding: 18px;
  }
`;
const CustomButton = styled(Button)`
  border-radius: 30px;
  height: 46px;
  font-size: 14px;
  text-transform: capitalize;
  padding: 8px 32px;
  background: white;
  color: ${colors.primary};
  border: 1px solid ${colors.primary};
  margin-top: 24px;
  text-decoration: none;
`;
export default {
  Wrap,
  Title,
  Content,
  Description,
  Disclaimer,
  Button,
  Container,
  CustomButton,
};
